import type { Nullable, NullableFields, Tables } from "../types";

/**
 * This function generates a formatted address string based on the provided fields.
 * @param fields - The fields to be used to create the address string.
 * @returns
 */
export function getAddressString(
	fields: Nullable<
		NullableFields<Pick<Tables<"projects">, "streetName" | "houseNumber" | "zipCode" | "city">>
	>,
	guardString = "--",
): string {
	const streetName = fields?.streetName ?? "";
	const houseNumber = fields?.houseNumber ?? "";
	const zipCode = fields?.zipCode ?? "";
	const city = fields?.city ?? "";

	if (streetName && houseNumber && zipCode && city)
		return `${streetName} ${houseNumber}, ${zipCode} ${city}`;
	if (streetName && houseNumber && city) return `${streetName} ${houseNumber}, ${city}`;
	if (streetName && houseNumber) return `${streetName} ${houseNumber}`;
	if (streetName && zipCode && city) return `${streetName}, ${zipCode} ${city}`;
	if (streetName && city) return `${streetName}, ${city}`;
	if (zipCode && city) return `${zipCode} ${city}`;
	if (city) return city;
	return guardString;
}
